module.exports = __webpack_public_path__ + "static/media/pencil-paintbrush.c0b23660.svg";